module.exports = __webpack_public_path__ + "img/therapist_planet.f832c75.png";